import { Dispatch } from "react";
import { uuid } from "uuidv4";
import { AppState } from "../reducers/rootReducer";
import projectService from "../services/projectService";
import formService from "../services/formService";
import { AppActions, EDIT_PROJECT, SET_PROJECT } from "../types/actions";
import { setElement } from "./elementListAction";
import { setForm } from "./formListAction";
import { setRow } from "./rowListAction";
import { setSection } from "./sectionListAction";
import { setTab } from "./tabListAction";
import { setSession, startEditSession, startSetSession } from "./sessionListAction";
import produce from "immer";
import { SystemTypes } from "../utils/constants";
import { Form } from "../models/formModel";
import { Project } from "../models/projectModel";

export const setProject = (projects: Project[]): AppActions => ({
    type: SET_PROJECT,
    projects
})

export const editProject = (project: Project): AppActions => ({
    type: EDIT_PROJECT,
    project
});

export const startLoadProjects = (userName: string) => {
    return async (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
        const { data } = await projectService.getProjectsByUserName({ userName });
        if (data.data) dispatch(setProject(data.data));
    };
};

export const startLoadProjectForms = (userName: string, projectId: string) => {
    return async (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
        let sessionState = getState().session;
        let newSessionState = produce(sessionState, draft => { draft.selectedProjectId = projectId; draft.selectedFormId = ''; draft.selectedType = '';});
        dispatch(setSession(newSessionState));
        localStorage.setItem('session', JSON.stringify(newSessionState));
        const { data } = await projectService.getFormsByProject({ userName: userName, id: projectId });
        if (data.data) {
            dispatch(setForm(data.data));
        }
    };
};

export const startLoadProjectSession = (userName: string, projectId: string, formId: string, ) => {
    return async (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
        const { data } = await projectService.getProject({ userName: userName, projectId: projectId , formId: formId });
        if (data.data) {
            dispatch(setForm(data.data.formList));
            dispatch(setRow(data.data.rowList));
            dispatch(setSection(data.data.sectionList));
            dispatch(setElement(data.data.elementList));
            dispatch(setTab(data.data.tabList));
        }
    };
};

export const startUpdateProject = (project: Project) => {
    return (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
        projectService.updateProject(project);
        dispatch(editProject(project));
    };
};


export const startLoadProject = (projectId: string, projectName: string, formId: string, formName: string, type: string, modalAttribute: any) => async (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    // const { data } = await projectService.getAll();
    const { data } = await projectService.createProject({ projectId: projectId, projectName: projectName, formId: formId, formName: formName, type: type, modalAttribute: modalAttribute });
    const reduxStore = await formService.getFormById(data.data.selectedForm);
    if (reduxStore.formList.length > 0) dispatch(setForm(reduxStore.formList));
    if (reduxStore.rowList.length > 0) dispatch(setRow(reduxStore.rowList));
    if (reduxStore.sectionList.length > 0) dispatch(setSection(reduxStore.sectionList));
    if (reduxStore.elementList.length > 0) dispatch(setElement(reduxStore.elementList));
    if (reduxStore.tabList.length > 0) dispatch(setTab(reduxStore.tabList));

    let sessionState = getState().session;
    let newSessionState = produce(sessionState, draft => { draft.selectedProjectId = projectId; draft.selectedFormId = data.data.selectedForm.id; draft.selectedType = SystemTypes.FORM });
    dispatch(setSession(newSessionState));
    localStorage.setItem('session', JSON.stringify(newSessionState));
    if (reduxStore.formList.length > 0) {
        let form = reduxStore.formList.filter((form: Form) => { return form.id === data.data.selectedForm.id })[0];
        localStorage.setItem('form', JSON.stringify(form));
    }

}